/* RESPONSIBLE TEAM: team-fin-nux */

import Route from '@ember/routing/route';
import { inject as service } from '@ember/service';
import { ReactRoute } from 'embercom/lib/react-route';
import type RouterService from '@ember/routing/router-service';
import type AppService from 'embercom/services/app-service';

class FinStudioRoute extends Route {
  @service declare router: RouterService;
  @service declare appService: AppService;

  reactEnabled() {
    return true;
  }

  beforeModel() {
    if (!this.appService.app.canUseFinStudio) {
      this.router.transitionTo('apps.app.automation.fin-ai-agent.tutorials');
    }
  }
}

export default ReactRoute(FinStudioRoute);
